/**
 * VendorPortalProductAnalyticsService
 * Service for viewing product analytics (read-only).
 * Route: api/vendor-portal/products/{productId}/analytics
 */
import { VendorPortalBaseService } from './VendorPortalBaseService';
/**
 * VendorPortalProductAnalyticsService
 * Handles vendor product analytics viewing for the vendor portal (read-only).
 * Maps to /api/vendor-portal/products/{productId}/analytics endpoint
 */
export class VendorPortalProductAnalyticsService extends VendorPortalBaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? VendorPortalProductAnalyticsService.DEFAULT_SERVICE_PATH,
            basePath: config?.basePath ?? VendorPortalProductAnalyticsService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== GET ANALYTICS ====================
    /**
     * Get analytics for a specific product
     * GET /api/vendor-portal/products/{productId}/analytics
     */
    async getAnalytics(productId) {
        const response = await this.getAnalyticsRaw(productId);
        return response.data ?? [];
    }
    /**
     * Get analytics (raw response)
     */
    getAnalyticsRaw(productId) {
        return this.get(`${productId}/analytics`);
    }
}
VendorPortalProductAnalyticsService.DEFAULT_SERVICE_PATH = 'vendor-catalogs';
VendorPortalProductAnalyticsService.BASE_PATH = 'api/vendor-portal/products';
//# sourceMappingURL=VendorPortalProductAnalyticsService.js.map